// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> echo-ridge
// Generated: 2026-10-08T21:23:32.878Z
// Counts: 1 design, 76 content, 39 slot group, 5 collection binding, 8 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home? Start your application online to take the next step toward finding an apartment that fits your needs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": "property_bedrooms_range"
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Welcome to Echo Ridge, where modern living meets comfort at our apartment rentals in Northglenn, CO. Revel in stylish one- and two-bedroom </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/floor-plans/\"><span style=\"font-size: 16px;\"><u>apartments</u></span></a><span style=\"font-size: 16px;\">, and enjoy our stunning amenities, from a refreshing pool and state-of-the-art fitness center to a cozy clubhouse and inviting courtyard. Experience the lifestyle you deserve today!</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Have questions about our one- and two-bedroom </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/floor-plans/\"><span style=\"font-size: 16px;\"><u>apartments</u></span></a><span style=\"font-size: 16px;\"> for rent in Northglenn, CO? Our dedicated leasing team is here to answer any questions you may have.&nbsp;</span></p><p></p><p><span style=\"font-size: 16px;\">Reach out to us today by phone or fill out the contact form below to begin your journey to elevated living! We look forward to hearing from you</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">At Echo Ridge, choose from stylish one- and two-bedroom Northglenn, CO apartments, designed for modern living. With thoughtful layouts and ample natural light, each space feels like home. Browse our available apartment homes, enjoy an online </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/virtual-tour/\"><span style=\"font-size: 16px;\"><u>virtual tour,</u></span></a><span style=\"font-size: 16px;\"> and find the ideal floor plan that suits your lifestyle!</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Envision life beyond the ordinary at Echo Ridge, with stylish pet-friendly </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/floor-plans/\"><span style=\"font-size: 16px;\"><u>one- and two-bedroom apartments</u></span></a><span style=\"font-size: 16px;\"> for rent in Northglenn, CO. Indulge in resort-style </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/amenities/\"><span style=\"font-size: 16px;\"><u>amenities</u></span></a><span style=\"font-size: 16px;\"> like a sparkling pool, state-of-the-art fitness center, and inviting clubhouse. Picture yourself unwinding on your private balcony or hosting a barbecue in the tranquil courtyard. Your dream lifestyle awaits!</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Welcome to Echo Ridge, where modern living meets comfort at our Northglenn, CO apartments for rent. Choose from spacious </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/floor-plans/\"><span style=\"font-size: 16px;\"><u>one- and two-bedroom apartments</u></span></a><span style=\"font-size: 16px;\">, each featuring stylish interior features, like stainless steel appliances and walk-in closets. Enjoy on-site </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/amenities/\"><span style=\"font-size: 16px;\"><u>amenities</u></span></a><span style=\"font-size: 16px;\">, like our swimming pool or fitness center. Use our interactive map to find your perfect home today!</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">At Echo Ridge, life extends beyond your front door. Our </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/floor-plans/\"><span style=\"font-size: 16px;\"><u>apartments</u></span></a><span style=\"font-size: 16px;\"> near the Light Rail provide both comfort and convenience.&nbsp;<br></span></p><p><span style=\"font-size: 16px;\">We are located less than 5 miles from shopping at Denver Premium Outlets and Whole Foods Market, and less than 3 miles from Front Range Community College - Westminster. If you’re looking for entertainment, you can find some less than 5 miles from home at Water World, the Butterfly Pavilion, or Boondocks Food and Fun. Need more than what our 24-hour fitness center offers? You can get it at Life Time or Gold’s Gym. Into sports and parks? The Hyland Hills Golf Course, Legacy Ridge Golf Course, and Carpenter Park are nearby, and when it comes to grabbing a bite to eat, there’s always In-N-Out Burger, Cinzzetti’s, or Dave &amp; Buster’s Westminster.&nbsp;</span></p><p></p><p><span style=\"font-size: 16px;\">See what's around our community and explore more local favorites by checking out the map below!</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.stat_monthly_rent_value": {
    "overrideType": "VALUE",
    "customValue": "35-$70",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Welcome to Echo Ridge, your ideal Northglenn, CO apartment community offering stylish living in the heart of convenience. Choose from our thoughtfully designed </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/floor-plans/\"><span style=\"font-size: 16px;\"><u>one- and two-bedroom floor plans</u></span></a><span style=\"font-size: 16px;\"> that cater to your lifestyle, whether you’re seeking a cozy retreat or a spacious haven.&nbsp;</span></p><p><span style=\"font-size: 16px;\"><br></span></p><p><span style=\"font-size: 16px;\">Each apartment features modern interiors, from walk-in closets and stainless steel appliances to fireplaces and high-speed internet access. Each apartment also comes equipped with air conditioning, washer/dryer options, and cable readiness, ensuring you have everything you need at your fingertips.&nbsp;</span></p><p></p><p><span style=\"font-size: 16px;\">At Echo Ridge, we offer a wide variety of </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/amenities/\"><span style=\"font-size: 16px;\"><u>amenities</u></span></a><span style=\"font-size: 16px;\">. Here, you can unwind in our refreshing pool or stay active in our state-of-the-art fitness center. Connect with neighbors in our welcoming clubhouse or enjoy al fresco dining in our beautifully landscaped courtyard complete with grilling stations. With controlled access and on-site maintenance, you can enjoy peace of mind knowing your comfort is our priority.&nbsp;</span></p><p><span style=\"font-size: 16px;\">Plus, enjoy the convenience of package services and key fob entry for an added layer of security.&nbsp;</span></p><p></p><p><span style=\"font-size: 16px;\">Nestled in a </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/neighborhood/\"><span style=\"font-size: 16px;\"><u>prime location</u></span></a><span style=\"font-size: 16px;\">, Echo Ridge puts you close to shopping, dining, and entertainment while providing a tranquil retreat from the hustle and bustle.</span></p><p></p><p><span style=\"font-size: 16px;\">Explore our availability, </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/contact-us/\"><span style=\"font-size: 16px;\"><u>contact us</u></span></a><span style=\"font-size: 16px;\">, or schedule a tour to visit our community. Let Echo Ridge be the perfect backdrop for your next chapter in Northglenn!</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Echo Ridge in Northglenn, CO, choose from thoughtfully designed one- and two-bedroom floor plans that perfectly suit your lifestyle. Schedule a tour today and experience modern comforts and vibrant community life.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Thank you for your interest! A team member will reach out to you soon to help you find your dream home.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">At Echo Ridge, our thoughtfully designed one- and two-bedroom rentals in Northglenn, CO, offer the perfect blend of comfort and style. Experience vibrant living spaces tailored to your lifestyle. Immerse yourself in our community! Take a virtual tour, explore </span><a class=\"richtext-link\" href=\"https://www.echoridgeatnorthhills.com/gallery/\"><span style=\"font-size: 16px;\"><u>photos of our apartments and amenities</u></span></a><span style=\"font-size: 16px;\">, and discover why Echo Ridge is the ideal place to call home!&nbsp;</span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166803/01a0f8c9-221f-7498-be1f-ab85f7304521.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two adorable dogs relaxing on pillows on a cozy leather sofa indoors."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-7944-75d9-9a50-7ccc121837e6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of apartment building entrance with stone facade and arched windows."
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-b12d-713e-afa6-a05661911fa7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with cardio machines, free weights, and a weight machine."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166796/019f8063-7944-75d9-9a50-7ccc121837e6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Echo Ridge at North Hills building entrance with a stone facade and arched windows."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019fa545-aa7d-70bf-8f81-6af4a6f1952f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A playful puppy chases a tennis ball across a grassy field."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": 2,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-b12d-713e-afa6-a05661911fa7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with cardio machines, free weights, and a weight machine."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-e2fe-73fd-bb49-4ba5e68fbd2c.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-a548-703e-a4cd-7aaec5274506.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-de08-76b3-96bc-a8f0a25351aa.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-5845-7349-8cef-1fec29b8a1ac.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings and surrounding neighborhood with mountains in the background."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-56f4-703c-baf7-2c71fc27afcb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Echo Ridge at North Hills apartment buildings and the surrounding Northglenn neighborhood."
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019fa547-4017-7399-bf6f-6305c7f56bd3.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two women jogging on a brick path in a park"
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019fa545-5106-749c-8de9-a13e70e0ff41.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman sitting on a yoga mat with dumbbells and a water bottle."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": 3,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019d02d0-925a-75b9-9ad0-ba0d3ccc8aa8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Echo Ridge at North Hills monument sign with stone accents and landscaping."
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-7f83-714f-bc32-470083e961d0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Echo Ridge at North Hills apartment building exterior with stone accents and a monument sign."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166796/019d02d0-85f6-706f-bb47-05967048b2e4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of apartment building with balconies and windows on a sunny day."
      }
    }
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166796/019fa546-245f-712c-95d2-561d24c38f6b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Man running on a treadmill in the gym."
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166796/019fa545-aa7d-70bf-8f81-6af4a6f1952f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A playful puppy chases a tennis ball across a grassy field."
      }
    }
  },
  "propertyoverview.slide_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-5845-7349-8cef-1fec29b8a1ac.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-7cc4-73a7-9e38-d5842bfa4d12.webp"
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-b7aa-716c-9026-a19bcb1817af.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-a20b-75f9-9e05-cde9d88acba6.webp"
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-a548-703e-a4cd-7aaec5274506.webp"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-7944-75d9-9a50-7ccc121837e6.webp"
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-7979-75b8-93da-bb6a218c55df.webp"
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166796/019d20b7-4881-7379-a8a2-6989f873a71a.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-a20b-75f9-9e05-cde9d88acba6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious community lounge area with a fireplace, seating, and a reception desk."
      }
    }
  },
  "reviewshero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-7f83-714f-bc32-470083e961d0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Echo Ridge at North Hills apartment building exterior with stone accents and a monument sign."
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166796/019f8063-7944-75d9-9a50-7ccc121837e6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of apartment building entrance with stone facade and arched windows."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 10,
    "hiddenIds": null,
    "orderedIds": [
      "custom_f4a4b4c6-10a0-458c-aedd-284f1d5e3b48",
      "custom_4e4d58c8-17e6-4a78-8c18-451f7fe569bd",
      "custom_a09dd750-e750-4980-a944-25b8158ffa83",
      "custom_50ba0a24-c4e9-441e-8c57-45743686a833",
      "custom_ab5deab5-bdcf-4f0f-a163-a862097bedc2",
      "custom_c9b682f8-3ba6-47ed-9107-c303807f2934",
      "custom_cc5ba703-e86f-467c-8023-72ce66b05cc6",
      "custom_f2709e50-1bfa-476a-8dd3-6df91f0d397d",
      "custom_26af43d7-1d96-4007-b18d-e50ea6a048c5",
      "custom_9a16110c-bf58-4f75-884f-3b3618b65f67",
      "custom_d50c609e-21f4-43d2-9854-8ae35b778fb3",
      "custom_ddffbcc7-b757-4369-83e2-3523e9db6f1e",
      "custom_054f5b62-cfc9-46f5-8d3f-f60dd64b8d6d",
      "custom_25956d88-6a3a-4ab6-8de8-413a48192440",
      "custom_b1d567e4-59a8-400a-8411-c4f2fcc589e1",
      "custom_42fd32e7-9b10-418a-a1f2-4946d17d56bb",
      "custom_be6d1369-3351-4a11-bc83-a933d2692c18",
      "custom_812c84fa-23eb-4b19-bf32-1b2e1b358e43",
      "custom_3494bcce-822e-44e5-8fa0-9cf834841e6d",
      "custom_bc6b5796-ddac-4476-b5ed-01d5514c71fb",
      "custom_4fa1f486-075b-4bc1-83bc-0fbaec40a69c",
      "custom_c7170ae9-7f5c-4873-8a12-908f050cc0a4",
      "custom_daac26ce-8755-406e-b05b-e20e2300d17c",
      "custom_bcfa443d-10f1-4209-a989-e47d72474b75",
      "custom_79645d6f-188c-4415-92b8-ece178ca0c6a",
      "custom_ce58b8ae-67e2-48bd-9252-8020c2f5f310",
      "custom_3cd98371-69a7-47de-affb-4f2ef6d60907",
      "custom_db32eb60-9af3-4aed-a6dc-aa467855933e",
      "custom_ab348cb3-51a0-4412-99c7-b3e8def44e07",
      "custom_a7b41b3b-fdbb-4ea9-9813-e34e6907f56c",
      "custom_4e97845d-4b19-445c-9bbb-8dd229e986c5",
      "custom_d3b0ba22-4f06-48e2-9bb6-b7002d0a6cdc",
      "custom_f0dac508-adf4-4a2e-bd5c-4b79065b78c5",
      "custom_30662082-ff25-431f-bfe3-952709cedbe9",
      "custom_0b5080c3-4add-4df3-bcb2-1d886e17fbd9",
      "custom_0f38ec7e-430a-484c-b266-24c55e4e25a6",
      "custom_0b43288e-0fd3-47d9-b85d-fe2a73ff887f",
      "custom_9b729b19-14f4-42b5-aad7-e21ee1821b12",
      "custom_89e384f7-57ac-47c3-b14b-afaa895c6ab4",
      "custom_1e3d533b-f4b1-4c96-816e-20888c2631ba",
      "custom_a99224cd-706c-481f-8b63-e2b9c33f1ff7",
      "custom_ed5b31d7-c046-415c-a851-83fb37cd4755",
      "custom_cd408819-0541-47d9-acff-e7ab1b535143",
      "custom_3466c68f-b5da-4925-b5b5-845344a8c1b3",
      "custom_4a96971c-7143-4771-84af-f6e6c4e1627e",
      "custom_cab2e05e-6344-4f07-8ac8-5eb4ca09905c",
      "custom_6a8db1df-309e-4cee-87de-5419e605b29d",
      "custom_b1057496-5c76-481a-b43d-ed770e45d566",
      "custom_6bca0a89-20f2-4aa0-adc8-be1fc62551c0",
      "custom_151d6f4f-ac63-4450-b3c6-3d0f08fce21b",
      "custom_553c48d6-c2e0-4421-95a6-e36f556490e6",
      "custom_c249e7de-569b-4051-8a01-d86bfd952a5a",
      "custom_1abbbb81-0d16-46ae-862a-65b5966110cd",
      "custom_61aee7cb-cbda-4d98-997b-10e3d25c114c",
      "custom_e4433e97-f115-4d0b-89cc-17850de162b3",
      "custom_50f53b39-e348-4e14-840a-a9ff6a6dde20",
      "custom_5d8fc7ee-e3fc-45a0-9eac-acd790b43555",
      "custom_10d48bd3-ac0d-49f1-9da1-c87ed6661f2f",
      "custom_05623be6-1f7e-4d22-8d38-4106ec3b3546",
      "custom_403811e8-c514-425a-8643-ecea4f0c8e65",
      "custom_80eb7cd9-0598-4198-b49f-160b835508fc",
      "custom_635fa41d-4e94-4826-81fd-911583b2bac7"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_ab5deab5-bdcf-4f0f-a163-a862097bedc2",
      "custom_a99224cd-706c-481f-8b63-e2b9c33f1ff7",
      "custom_89e384f7-57ac-47c3-b14b-afaa895c6ab4",
      "custom_a09dd750-e750-4980-a944-25b8158ffa83",
      "custom_0b5080c3-4add-4df3-bcb2-1d886e17fbd9",
      "custom_f2709e50-1bfa-476a-8dd3-6df91f0d397d",
      "custom_d50c609e-21f4-43d2-9854-8ae35b778fb3",
      "custom_c9b682f8-3ba6-47ed-9107-c303807f2934",
      "custom_30662082-ff25-431f-bfe3-952709cedbe9",
      "custom_ddffbcc7-b757-4369-83e2-3523e9db6f1e",
      "custom_f0dac508-adf4-4a2e-bd5c-4b79065b78c5",
      "custom_0f38ec7e-430a-484c-b266-24c55e4e25a6",
      "custom_9b729b19-14f4-42b5-aad7-e21ee1821b12",
      "custom_1e3d533b-f4b1-4c96-816e-20888c2631ba",
      "custom_cc5ba703-e86f-467c-8023-72ce66b05cc6",
      "custom_4a96971c-7143-4771-84af-f6e6c4e1627e",
      "custom_ed5b31d7-c046-415c-a851-83fb37cd4755",
      "custom_cd408819-0541-47d9-acff-e7ab1b535143",
      "custom_9a16110c-bf58-4f75-884f-3b3618b65f67",
      "custom_26af43d7-1d96-4007-b18d-e50ea6a048c5",
      "custom_3466c68f-b5da-4925-b5b5-845344a8c1b3",
      "custom_cab2e05e-6344-4f07-8ac8-5eb4ca09905c",
      "custom_6a8db1df-309e-4cee-87de-5419e605b29d",
      "custom_b1057496-5c76-481a-b43d-ed770e45d566",
      "custom_6bca0a89-20f2-4aa0-adc8-be1fc62551c0",
      "custom_151d6f4f-ac63-4450-b3c6-3d0f08fce21b",
      "custom_553c48d6-c2e0-4421-95a6-e36f556490e6",
      "custom_c249e7de-569b-4051-8a01-d86bfd952a5a",
      "custom_1abbbb81-0d16-46ae-862a-65b5966110cd",
      "custom_61aee7cb-cbda-4d98-997b-10e3d25c114c",
      "custom_e4433e97-f115-4d0b-89cc-17850de162b3",
      "custom_f4a4b4c6-10a0-458c-aedd-284f1d5e3b48",
      "custom_50f53b39-e348-4e14-840a-a9ff6a6dde20",
      "custom_5d8fc7ee-e3fc-45a0-9eac-acd790b43555",
      "custom_10d48bd3-ac0d-49f1-9da1-c87ed6661f2f",
      "custom_05623be6-1f7e-4d22-8d38-4106ec3b3546",
      "custom_403811e8-c514-425a-8643-ecea4f0c8e65",
      "custom_80eb7cd9-0598-4198-b49f-160b835508fc",
      "custom_635fa41d-4e94-4826-81fd-911583b2bac7"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_b1057496-5c76-481a-b43d-ed770e45d566",
      "custom_1abbbb81-0d16-46ae-862a-65b5966110cd",
      "custom_553c48d6-c2e0-4421-95a6-e36f556490e6",
      "custom_61aee7cb-cbda-4d98-997b-10e3d25c114c",
      "custom_5d8fc7ee-e3fc-45a0-9eac-acd790b43555",
      "custom_403811e8-c514-425a-8643-ecea4f0c8e65",
      "custom_4fa1f486-075b-4bc1-83bc-0fbaec40a69c",
      "custom_3494bcce-822e-44e5-8fa0-9cf834841e6d",
      "custom_4e97845d-4b19-445c-9bbb-8dd229e986c5",
      "custom_bcfa443d-10f1-4209-a989-e47d72474b75",
      "custom_812c84fa-23eb-4b19-bf32-1b2e1b358e43",
      "custom_6a8db1df-309e-4cee-87de-5419e605b29d",
      "custom_635fa41d-4e94-4826-81fd-911583b2bac7"
    ],
    "orderedIds": [
      "custom_ed5b31d7-c046-415c-a851-83fb37cd4755",
      "custom_3466c68f-b5da-4925-b5b5-845344a8c1b3",
      "custom_6bca0a89-20f2-4aa0-adc8-be1fc62551c0",
      "custom_e4433e97-f115-4d0b-89cc-17850de162b3",
      "custom_26af43d7-1d96-4007-b18d-e50ea6a048c5",
      "custom_635fa41d-4e94-4826-81fd-911583b2bac7",
      "custom_80eb7cd9-0598-4198-b49f-160b835508fc",
      "custom_a99224cd-706c-481f-8b63-e2b9c33f1ff7",
      "custom_cc5ba703-e86f-467c-8023-72ce66b05cc6",
      "custom_cab2e05e-6344-4f07-8ac8-5eb4ca09905c",
      "custom_151d6f4f-ac63-4450-b3c6-3d0f08fce21b",
      "custom_89e384f7-57ac-47c3-b14b-afaa895c6ab4",
      "custom_9b729b19-14f4-42b5-aad7-e21ee1821b12",
      "custom_f2709e50-1bfa-476a-8dd3-6df91f0d397d",
      "custom_1e3d533b-f4b1-4c96-816e-20888c2631ba",
      "custom_0b43288e-0fd3-47d9-b85d-fe2a73ff887f",
      "custom_c9b682f8-3ba6-47ed-9107-c303807f2934",
      "custom_0b5080c3-4add-4df3-bcb2-1d886e17fbd9",
      "custom_a09dd750-e750-4980-a944-25b8158ffa83",
      "custom_30662082-ff25-431f-bfe3-952709cedbe9",
      "custom_f0dac508-adf4-4a2e-bd5c-4b79065b78c5",
      "custom_6a8db1df-309e-4cee-87de-5419e605b29d",
      "custom_b1057496-5c76-481a-b43d-ed770e45d566",
      "custom_1abbbb81-0d16-46ae-862a-65b5966110cd",
      "custom_553c48d6-c2e0-4421-95a6-e36f556490e6",
      "custom_61aee7cb-cbda-4d98-997b-10e3d25c114c",
      "custom_5d8fc7ee-e3fc-45a0-9eac-acd790b43555",
      "custom_403811e8-c514-425a-8643-ecea4f0c8e65",
      "custom_4fa1f486-075b-4bc1-83bc-0fbaec40a69c",
      "custom_ab348cb3-51a0-4412-99c7-b3e8def44e07",
      "custom_3cd98371-69a7-47de-affb-4f2ef6d60907",
      "custom_50ba0a24-c4e9-441e-8c57-45743686a833",
      "custom_db32eb60-9af3-4aed-a6dc-aa467855933e",
      "custom_3494bcce-822e-44e5-8fa0-9cf834841e6d",
      "custom_bc6b5796-ddac-4476-b5ed-01d5514c71fb",
      "custom_42fd32e7-9b10-418a-a1f2-4946d17d56bb",
      "custom_c7170ae9-7f5c-4873-8a12-908f050cc0a4",
      "custom_bcfa443d-10f1-4209-a989-e47d72474b75",
      "custom_4e97845d-4b19-445c-9bbb-8dd229e986c5",
      "custom_d3b0ba22-4f06-48e2-9bb6-b7002d0a6cdc",
      "custom_054f5b62-cfc9-46f5-8d3f-f60dd64b8d6d",
      "custom_be6d1369-3351-4a11-bc83-a933d2692c18",
      "custom_79645d6f-188c-4415-92b8-ece178ca0c6a",
      "custom_a7b41b3b-fdbb-4ea9-9813-e34e6907f56c",
      "custom_812c84fa-23eb-4b19-bf32-1b2e1b358e43",
      "custom_daac26ce-8755-406e-b05b-e20e2300d17c"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0,
      "visible": false
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
